// Editorial dates supplied by the user for the 2026 planning calendar.
// These are observances, not a list of statutory public holidays.
const historicalOccasions2026 = [
  ['01-03', 'Savitribai Phule Jayanti'],
  ['01-11', 'Lal Bahadur Shastri Death Anniversary'],
  ['01-22', 'Kokborok Day', 'Tripura'],
  ['02-01', 'Kalpana Chawla Death Anniversary (Columbia Disaster)'],
  ['02-02', 'Maharshi Dayanand Saraswati Birth Anniversary'],
  ['02-13', 'Sarojini Naidu Birth Anniversary'],
  ['02-16', 'Ol Chiki Script Centenary Commemoration Begins'],
  ['02-17', 'Karpoori Thakur Death Anniversary'],
  ['02-21', 'International Mother Language Day / Bangla Language Movement Remembrance'],
  ['02-22', 'Maulana Abul Kalam Azad Death Anniversary'],
  ['02-24', 'J. Jayalalithaa Birth Anniversary'],
  ['03-03', 'Jamsetji Tata Birth Anniversary'],
  ['03-05', 'Biju Patnaik Birth Anniversary'],
  ['03-06', 'Maharaja Sayajirao Gaekwad III Birth Anniversary'],
  ['03-07', 'Govind Ballabh Pant Death Anniversary'],
  ['03-10', 'Savitribai Phule Death Anniversary'],
  ['03-12', 'Dandi March Anniversary'],
  ['03-15', 'Kanshi Ram Birth Anniversary'],
  ['03-16', 'Satyendra Nath Bose Death Anniversary'],
  ['03-17', 'Kalpana Chawla Birth Anniversary'],
  ['03-20', "Dr. B. R. Ambedkar's Mahad Satyagraha Anniversary"],
  ['03-21', 'Ustad Bismillah Khan Birth Anniversary'],
  ['03-22', 'Bihar Diwas', 'Bihar'],
  ['03-30', 'Rajasthan Day', 'Rajasthan'],
  ['04-03', 'Chhatrapati Shivaji Maharaj Death Anniversary'],
  ['04-06', 'Dandi March Conclusion / Salt Law Defiance Anniversary'],
  ['04-11', 'Jyotirao Phule Birth Anniversary'],
  ['04-13', 'Jallianwala Bagh Massacre Remembrance'],
  ['04-14', 'Rahul Sankrityayan Birth Anniversary'],
  ['04-18', 'Tatya Tope Death Anniversary'],
  ['04-24', 'Sachin Tendulkar Birth Anniversary'],
  ['05-03', 'V. K. Krishna Menon Birth Anniversary'],
  ['05-07', 'Ashwini Kumar Dutta Birth Anniversary'],
  ['05-07', 'Rabindranath Tagore Birth Anniversary (Gregorian Date)'],
  ['05-09', 'Gopal Krishna Gokhale Birth Anniversary'],
  ['05-11', 'Pokhran-II Nuclear Tests Anniversary'],
  ['05-15', 'Sukhdev Thapar Birth Anniversary'],
  ['05-22', 'Raja Ram Mohan Roy Birth Anniversary'],
  ['05-27', 'Jawaharlal Nehru Death Anniversary'],
  ['05-28', 'Vinayak Damodar Savarkar Birth Anniversary'],
  ['05-29', 'Everest Summit Anniversary: Tenzing Norgay and Edmund Hillary'],
  ['05-31', 'Ahilyabai Holkar Birth Anniversary'],
  ['06-09', 'Birsa Munda Death Anniversary'],
  ['06-11', 'Ram Prasad Bismil Birth Anniversary'],
  ['06-18', 'Rani Lakshmibai Martyrdom Anniversary'],
  ['06-23', 'Syama Prasad Mookerjee Death Anniversary'],
  ['06-25', 'Emergency Proclamation Anniversary / Samvidhan Hatya Diwas'],
  ['06-27', 'Bankim Chandra Chattopadhyay Birth Anniversary'],
  ['06-29', 'P. C. Mahalanobis Birth Anniversary / National Statistics Day'],
  ['07-01', "Dr. Bidhan Chandra Roy Birth and Death Anniversary / National Doctors' Day"],
  ['07-04', 'Swami Vivekananda Death Anniversary'],
  ['07-06', 'Dr. Syama Prasad Mookerjee Birth Anniversary'],
  ['07-19', 'Mangal Pandey Birth Anniversary'],
  ['07-20', 'Batukeshwar Dutt Death Anniversary'],
  ['07-22', 'Indian National Flag Adoption Anniversary'],
  ['07-23', 'Bal Gangadhar Tilak Birth Anniversary'],
  ['07-23', 'Chandra Shekhar Azad Birth Anniversary'],
  ['07-27', 'Dr. A. P. J. Abdul Kalam Death Anniversary'],
  ['07-31', 'Shaheed Udham Singh Martyrdom Anniversary'],
  ['08-01', 'Bal Gangadhar Tilak Death Anniversary'],
  ['08-01', 'Non-Cooperation Movement Launch Anniversary'],
  ['08-02', 'Pingali Venkayya Birth Anniversary'],
  ['08-06', 'Hiroshima Remembrance Day'],
  ['08-07', 'Rabindranath Tagore Death Anniversary'],
  ['08-08', 'Quit India Resolution Anniversary'],
  ['08-09', 'Quit India Movement Anniversary / August Kranti Diwas'],
  ['08-11', 'Khudiram Bose Martyrdom Anniversary'],
  ['08-12', 'Vikram Sarabhai Birth Anniversary'],
  ['08-13', 'Ahilyabai Holkar Death Anniversary'],
  ['08-14', 'Partition Horrors Remembrance Day'],
  ['08-15', 'Sri Aurobindo Birth Anniversary'],
  ['08-17', 'Madan Lal Dhingra Martyrdom Anniversary'],
  ['08-20', 'Rajiv Gandhi Birth Anniversary / Sadbhavana Diwas'],
  ['08-24', 'Shivaram Rajguru Birth Anniversary'],
  ['08-26', 'Mother Teresa Birth Anniversary'],
  ['08-29', "Major Dhyan Chand Birth Anniversary / National Sports Day"],
  ['08-30', 'Dadabhai Naoroji Death Anniversary'],
  ['09-04', 'Dadabhai Naoroji Birth Anniversary'],
  ['09-05', "Dr. Sarvepalli Radhakrishnan Birth Anniversary / Teachers' Day"],
  ['09-06', 'Sarat Chandra Bose Birth Anniversary'],
  ['09-08', 'Bhupen Hazarika Birth Anniversary'],
  ['09-11', 'Vinoba Bhave Birth Anniversary'],
  ['09-12', 'Saragarhi Day / Battle of Saragarhi Anniversary'],
  ['09-13', 'Jatindra Nath Das Death Anniversary'],
  ['09-14', 'Hindi Diwas / Constituent Assembly Official-Language Decision Anniversary'],
  ['09-15', "M. Visvesvaraya Birth Anniversary / Engineers' Day"],
  ['09-17', 'E. V. Ramasamy Periyar Birth Anniversary'],
  ['09-20', 'Sree Narayana Guru Samadhi Day'],
  ['09-23', 'Ramdhari Singh Dinkar Birth Anniversary'],
  ['09-25', 'Deendayal Upadhyaya Birth Anniversary'],
  ['09-27', 'Raja Ram Mohan Roy Death Anniversary'],
  ['09-28', 'Lata Mangeshkar Birth Anniversary'],
  ['09-28', 'Shaheed Bhagat Singh Birth Anniversary'],
  ['09-29', 'Matangini Hazra Martyrdom Anniversary'],
  ['10-01', 'Annie Besant Birth Anniversary'],
  ['10-04', 'Shyamji Krishna Varma Birth Anniversary'],
  ['10-08', 'Munshi Premchand Death Anniversary'],
  ['10-10', 'R. K. Narayan Birth Anniversary'],
  ['10-11', 'Jayaprakash Narayan Birth Anniversary'],
  ['10-11', 'Nanaji Deshmukh Birth Anniversary'],
  ['10-15', 'Dr. A. P. J. Abdul Kalam Birth Anniversary'],
  ['10-17', 'Sir Syed Ahmad Khan Birth Anniversary'],
  ['10-21', 'Azad Hind Government Formation Anniversary'],
  ['10-23', 'Kittur Rani Chennamma Uprising Anniversary', 'All India', 'Historical date requires verification'],
  ['10-27', "Infantry Day / Indian Army's 1947 Srinagar Landing"],
  ['10-28', 'Sister Nivedita Birth Anniversary'],
  ['10-29', 'Kamaladevi Chattopadhyay Death Anniversary'],
  ['10-31', 'Indira Gandhi Death Anniversary'],
  ['11-01', 'Kerala Piravi / Kerala Formation Day', 'Kerala'],
  ['11-07', 'Vande Mataram 150-Year Commemoration', 'All India', 'Year-long programme concludes in 2026; the 150th anniversary was in 2025'],
  ['11-16', 'Kartar Singh Sarabha Martyrdom Anniversary'],
  ['11-17', 'Lala Lajpat Rai Death Anniversary'],
  ['11-19', 'Indira Gandhi Birth Anniversary'],
  ['11-19', 'Rani Lakshmibai Birth Anniversary'],
  ['11-21', 'Harekrushna Mahatab Birth Anniversary'],
  ['11-24', "Guru Tegh Bahadur Ji's 350th Shaheedi Year Commemoration"],
  ['11-26', 'Constitution Adoption Anniversary / Constitution Day'],
  ['11-30', 'Jagadish Chandra Bose Birth Anniversary'],
  ['12-02', 'Sukapha Divas / Assam Divas', 'Assam'],
  ['12-03', 'Dr. Rajendra Prasad Birth Anniversary'],
  ['12-04', 'R. C. Majumdar Birth Anniversary'],
  ['12-06', 'Dr. B. R. Ambedkar Death Anniversary / Mahaparinirvan Diwas'],
  ['12-08', 'Bipin Chandra Pal Death Anniversary'],
  ['12-10', 'C. Rajagopalachari Birth Anniversary'],
  ['12-11', 'Pranab Mukherjee Birth Anniversary'],
  ['12-15', 'Sardar Vallabhbhai Patel Death Anniversary'],
  ['12-16', 'Vijay Diwas / 1971 War Anniversary'],
  ['12-18', 'Guru Ghasidas Jayanti'],
  ['12-19', 'Goa Liberation Day', 'Goa'],
  ['12-22', 'Srinivasa Ramanujan Birth Anniversary / National Mathematics Day'],
  ['12-23', 'Chaudhary Charan Singh Birth Anniversary / Kisan Diwas'],
  ['12-24', 'Mohammed Rafi Birth Anniversary'],
  ['12-25', 'Atal Bihari Vajpayee Birth Anniversary / Good Governance Day'],
  ['12-25', 'Madan Mohan Malaviya Birth Anniversary'],
  ['12-26', 'Veer Bal Diwas / Sahibzade Remembrance'],
  ['12-27', 'Mirza Ghalib Birth Anniversary'],
  ['12-30', "Subhas Chandra Bose's 1943 Port Blair Flag-Hoisting Anniversary"]
];

export default historicalOccasions2026;
